// extracted by mini-css-extract-plugin
export default {"fallbackImage":"FallbackImage--fallbackImage--ZoFJS"};